import {Notifications} from "./notifications";
import {setAjaxModalContent, setModalContent} from "./modals";

export class Clipboard{
    static init() {
        document.querySelectorAll("[data-clipboard-text]").forEach(target => {
            const clipboard = new ClipboardJS(target);

            clipboard.on('success', e => {
                Notifications.showSuccess({ message: "The URL has been copied to your clipboard." })
            });
        });


        document.addEventListener("click", async e => {
            const target = e.target.closest("[data-copy-link]")
            if (!target)
                return;

            e.preventDefault();

            const url = target.dataset.copyLink;

            await setAjaxModalContent(`/copy-link?url=${encodeURI(url)}`);

            document.querySelectorAll("[data-clipboard-target]").forEach(target => {
                const clipboard = new ClipboardJS(target);

                clipboard.on('success', e => {
                    Notifications.showSuccess({ message: "The URL has been copied to your clipboard." })
                });
            });
        });
    }
}
